function CustomTable(props) {
  const { tableHeaderList, tableBody } = props;

  return (
    <table className="table align-middle text-nowrap table-hover table-centered">
      <thead className="bg-light-subtle">
        <tr>
          <th style={{ width: "10px" }}>
            <div className="form-check">
              <input type="checkbox" className="form-check-input" />
              <label className="form-check-label"></label>
            </div>
          </th>
          {tableHeaderList.map((item, idx) => {
            return <th key={idx}>{item}</th>;
          })}
        </tr>
      </thead>
      <tbody>{tableBody()}</tbody>
    </table>
  );
}

export default CustomTable;
